"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../0.0.1");
require("./label-source");
